import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Deklaracja cookies", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { id: "cookie-bot-declaration" }, null, -1)
const _hoisted_3 = [
  _hoisted_1,
  _hoisted_2
]

import { onMounted } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CookiesDeclarationSettings',
  setup(__props) {

onMounted(() => {
  const scriptTag = document.createElement("script");
  scriptTag.src =
    "https://consent.cookiebot.com/efdd1357-109a-42d2-ade7-9ad1dd49a91a/cd.js";
  scriptTag.id = "CookieDeclaration";
  scriptTag.type = "text/javascript";
  scriptTag.async = true;
  document.getElementById("cookie-bot-declaration")!.append(scriptTag);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, _hoisted_3))
}
}

})